module.exports = __webpack_public_path__ + "static/media/boy-12.c63dc6c5.svg";